import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

export const MILE_IN_METRES = 1609.344;

/** Browser key, referrer-restricted to the app. Empty until infra provisions it (ONE-7232). */
export const googleMapsBrowserKey = (): string =>
  (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) ?? '';

let configuredKey: string | null = null;

/** Loads the Maps JavaScript API once per page and returns the `maps` library. */
export async function loadMapsLibrary(apiKey: string): Promise<google.maps.MapsLibrary> {
  if (configuredKey === null) {
    setOptions({ key: apiKey, v: 'weekly' });
    configuredKey = apiKey;
  }
  return importLibrary('maps');
}
